export default {
  GET_INVESTMENT_PERSON_REPOSITORY: Symbol.for('GET_INVESTMENT_PERSON_REPOSITORY'),
  GET_INVESTMENT_PERSON_QUERY: Symbol.for('GET_INVESTMENT_PERSON_QUERY'),
  GET_PERSON_ASYNC_QUERY: Symbol.for('GET_PERSON_ASYNC_QUERY'),
  UPDATE_INVESTMENT_PERSON_REPOSITORY: Symbol.for('UPDATE_INVESTMENT_PERSON_REPOSITORY'),
  UPDATE_INVESTMENT_PERSON_COMMAND: Symbol.for('UPDATE_INVESTMENT_PERSON_COMMAND'),
  INVESTMENT_PERSON_STATE_MANAGER: Symbol.for('INVESTMENT_PERSON_STATE_MANAGER'),
};
